module.exports = __webpack_public_path__ + "static/media/photo291.a0bee2bf.jpg";